/** Display constants for the Disposition & Treatment Matrix (Iter 39). Pure. */

export const TREATMENTS = ["keep", "reface", "refactor", "re-represent", "re-engineer", "replace"];
export const DISPOSITIONS = ["retain", "wrap", "externalize", "move", "archive", "retire"];
export const STATES = ["proposed", "validated", "rejected", "ai_inferred"];

export const TREATMENT_HELP = {
  keep: "No code change — leave the object as it is",
  reface: "New UI / API surface over unchanged logic",
  refactor: "Restructure code without changing behaviour",
  "re-represent": "Change the data representation (e.g. DDS → SQL DDL) keeping semantics",
  "re-engineer": "Rebuild the logic with new design",
  replace: "Substitute with a package or new system",
};

export const DISPOSITION_HELP = {
  retain: "Stays on IBM i as the system of record",
  wrap: "Kept, exposed through a service/API wrapper",
  externalize: "Logic moves out to a service; IBM i keeps the data or is called back",
  move: "Relocated to another platform/database",
  archive: "Data preserved read-only; active use stops",
  retire: "Decommissioned outright",
};

export const STATE_LABEL = {
  ai_inferred: "AI inferred",
  proposed: "Proposed",
  validated: "Validated",
  rejected: "Rejected",
};

export const STATE_CLASS = {
  ai_inferred: "bg-[#8a3ffc]/10 text-[#6929c4] border-[#8a3ffc]/30",
  proposed: "bg-[var(--ml-warning)]/15 text-[#8a6d00] border-[var(--ml-warning)]/40",
  validated: "bg-[#0e6027]/10 text-[#0e6027] border-[#0e6027]/30",
  rejected: "bg-[var(--ml-error)]/10 text-[var(--ml-error)] border-[var(--ml-error)]/30",
};

export const SIGNAL_LABEL = {
  high_risk_file: "High-risk file",
  decommission_radar: "Decommission radar",
  orphan_file: "Orphan file",
  microservice_candidate: "Microservice candidate",
};

export const ORIGIN_LABEL = {
  deterministic: "Deterministic rule",
  manual: "Consultant",
  llm: "LLM",
};

/** Iter 49 — stale flag: the driving deterministic signal no longer fires. Carbon orange. */
export const STALE_CLASS = "bg-[#ff832b]/15 text-[#8a3800] border-[#ff832b]/50";
export const STALE_LABEL = "Stale";
export const STALE_HINT = "Driving signal no longer fires after re-import / re-seed — original proposal kept, review before validating.";

export function signalLabel(s) {
  return SIGNAL_LABEL[s] || s || "none";
}

/** "orphan file → no signal fires" for a stale row; null when the row is fresh. */
export function staleTransition(d) {
  if (!d?.stale) return null;
  const prev = signalLabel(d.previous_signal || d.signal);
  const now = d.current_signal ? signalLabel(d.current_signal) : "no signal fires";
  return `${prev} → ${now}`;
}

export function stateLabel(s) {
  return STATE_LABEL[s] || s || "—";
}

export function stateClass(s) {
  return STATE_CLASS[s] || STATE_CLASS.proposed;
}

export function objectLabel(d) {
  return `${d.library_name}/${d.object_name}`;
}
